// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__BdaUe","container":"recipe_container__X6Az9"};